import {gql} from '@apollo/client';

import {BenchlingQueryResult, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {AllRequestSchemasQuery} from './__generated/AllRequestSchemasQuery';

export const ALL_REQUEST_SCHEMAS_QUERY = gql`
  query AllRequestSchemasQuery @skipAudit @engComponent(name: REQUESTS) {
    requestSchemas {
      ...RequestSchemaGraphQL
    }
  }
  ${getFragmentWrapper('RequestSchema').fragment}
`;

export const useAllRequestSchemasQuery = (): BenchlingQueryResult<AllRequestSchemasQuery> =>
  useBenchlingQuery<AllRequestSchemasQuery>(ALL_REQUEST_SCHEMAS_QUERY);
